import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames, toArray } from '@shapeable/utils';
import { EntityFilterSelect, entitySelectSlugTransform, useLang, useView } from '@shapeable/ui';
import { compact, keyBy, mapValues } from 'lodash';
import { sprintf } from 'sprintf-js';
import { usePublicationFilters } from '../../hooks/use-publication-filters';

const cls = classNames('publication-select-filters');

export type PublicationSelectFiltersProps = {
  view: string;
};

const SelectStyles = breakpoints({
  base: css`
    width: 100%;
    min-width: 0;
  `,
});

const My = {
  Select: styled(EntityFilterSelect)`${SelectStyles}`,
};

export const PublicationSelectFilters: Shapeable.FC<PublicationSelectFiltersProps> = (props) => {
  const { view } = props;

  const t = useLang();
  const { selects } = usePublicationFilters();
  const { filters, onEntityFilterChange } = useView(view);

  const selectsDictionary = React.useMemo(
    () => mapValues(keyBy(selects, 'name'), (item) => keyBy(item.items, 'slug')),
    [selects],
  );

  if (!selects.length) {
    return null;
  }

  return (
    <>
      {selects.map((select) => {
        const value = filters[select.name] || [];
        const selectValue = compact(toArray(value).map((slug) => {
          const entity = selectsDictionary[select.name]?.[slug];
          return entity ? entitySelectSlugTransform(entity) : null;
        }));

        return (
          <My.Select
            key={select.name}
            className={cls.attr('select', select.name)}
            value={selectValue}
            transform={entitySelectSlugTransform}
            onChange={(items) => onEntityFilterChange(select.name, items)}
            size="slim"
            placeholder={sprintf(t('(All %s)'), select.pluralLabel)}
            isClearable
            isMulti
            items={select.items}
          />
        );
      })}
    </>
  );
};

PublicationSelectFilters.cls = cls;
